/* =============================================================================
   pl-v8.js — diagnóstico de un toque, tabla comparativa y barras de ahorro (gen-secciones10.js)
   Todo con anime.js: los efectos se registran en ONX.effects y motion.js los dispara al entrar
   a la vista (data-anim="pdx-ops" | "plc" | "pah"). Solo transform/opacity: ligero en celular.
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.effects = ONX.effects || {};
  var A = function () { return window.anime; };
  var TONOS = ['#9A7663', '#C9A08F', '#E8C9B5', '#F4B183', '#1F7A3F'];
  var cols = function () { return window.matchMedia('(min-width: 750px)').matches ? 3 : 2; };

  // chispas que salen de un punto (x, y relativos a host) y se borran solas
  function chispas(host, x, y, n, tonos) {
    var a = A(); if (!a || !host) return;
    for (var i = 0; i < n; i++) (function (d) {
      d.className = 'onx-chispa'; d.style.left = x + 'px'; d.style.top = y + 'px';
      d.style.background = (tonos || TONOS)[i % (tonos || TONOS).length];
      host.appendChild(d);
      var ang = Math.PI * 2 * i / n + Math.random() * 0.6, r = 46 + Math.random() * 56;
      a.animate(d, { x: Math.cos(ang) * r, y: Math.sin(ang) * r - 18, rotate: Math.random() * 360, scale: [1.2, 0], opacity: [1, 0],
        duration: 750 + Math.random() * 350, ease: 'outExpo', onComplete: function () { d.remove(); } });
    })(document.createElement('i'));
  }
  function centro(el, host) {
    var r = el.getBoundingClientRect(), h = host.getBoundingClientRect();
    return { x: r.left - h.left + r.width / 2, y: r.top - h.top + r.height / 2 };
  }

  /* ---------------------------------------------------------- diagnóstico */
  ONX.effects['pdx-ops'] = function (el, a, o) {
    var btns = el.querySelectorAll('.pdx__op');
    a.utils.set(btns, { opacity: 0, scale: 0.7, y: 18 });
    return a.animate(btns, { opacity: 1, scale: 1, y: 0, duration: 800, ease: 'outBack(1.8)', delay: a.stagger(70, { from: 'center', start: o.delay }) });
  };

  function initDx(root) {
    (root || document).querySelectorAll('[data-pdx]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var host = box.querySelector('.pdx__in'), grid = box.querySelector('.pdx__ops');
      var res = box.querySelector('[data-pdx-res]'), ops = box.querySelectorAll('[data-pdx-op]'), puntos = res.querySelectorAll('.pdx__scan i');
      var turno = 0;
      ops.forEach(function (op) {
        op.addEventListener('click', function (e) {
          var a = A(), i = op.getAttribute('data-pdx-op'), mio = ++turno;
          grid.classList.remove('is-wait'); grid.classList.add('has-pick');
          ops.forEach(function (x) { x.setAttribute('aria-checked', String(x === op)); });
          res.hidden = false; res.classList.add('is-scan');
          res.querySelectorAll('[data-pdx-card]').forEach(function (c) { c.hidden = true; });
          if (res.getBoundingClientRect().top > innerHeight * 0.72) res.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var caso = op.querySelector('.pdx__lbl').textContent.trim();
          try { if (window.clarity) clarity('set', 'diagnostico', caso); (window.dataLayer = window.dataLayer || []).push({ event: 'diagnostico', caso: caso }); } catch (err) {}
          var mostrar = function () {
            if (mio !== turno) return;
            res.classList.remove('is-scan');
            var card = res.querySelector('[data-pdx-card="' + i + '"]'); card.hidden = false;
            if (!a) return;
            var partes = card.querySelectorAll('.pdx__t, .pdx__txt, .pdx__reco, .pdx__btn, .pdx__note');
            a.utils.set(partes, { opacity: 0, y: 12 });
            a.animate(card, { opacity: [0, 1], y: [24, 0], scale: [0.96, 1], duration: 700, ease: 'outExpo' });
            a.animate(partes, { opacity: 1, y: 0, duration: 600, delay: a.stagger(70, { start: 120 }), ease: 'outExpo' });
          };
          if (!a) return mostrar();
          var rb = op.getBoundingClientRect(), rip = document.createElement('span');
          rip.className = 'pdx__rip'; rip.style.left = ((e.clientX || rb.left + rb.width / 2) - rb.left) + 'px'; rip.style.top = ((e.clientY || rb.top + rb.height / 2) - rb.top) + 'px';
          op.appendChild(rip);
          a.animate(rip, { scale: [0, 6], opacity: [0.4, 0], duration: 600, ease: 'outQuad', onComplete: function () { rip.remove(); } });
          a.animate(op, { scale: [0.9, 1], duration: 600, ease: 'outElastic(1, .5)' });
          var c = centro(op, host); chispas(host, c.x, c.y, 8);
          // tres puntos que saltan un instante y sale el resultado
          a.animate(puntos, { y: [0, -8, 0], duration: 420, delay: a.stagger(90), loop: 1, ease: 'inOutSine' });
          setTimeout(mostrar, 900);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initDx(); }); else initDx();
  document.addEventListener('shopify:section:load', function (e) { initDx(e.target); });

  /* ------------------------------------------------------------- comparativa */
  ONX.effects.plc = function (el, a, o) {
    var filas = el.querySelectorAll('.plc__row:not(.plc__head)'), si = el.querySelectorAll('.plc__ok'), no = el.querySelectorAll('.plc__no');
    a.utils.set(filas, { opacity: 0, x: -36 });
    a.utils.set(si, { scale: 0, rotate: -140 });
    a.utils.set(no, { scale: 0.4, opacity: 0 });
    a.animate(filas, { opacity: 1, x: 0, duration: 800, delay: a.stagger(110, { start: o.delay }), ease: 'outExpo' });
    a.animate(si, { scale: 1, rotate: 0, duration: 900, delay: a.stagger(110, { start: o.delay + 260 }), ease: 'outBack(2.6)' });
    a.animate(no, { scale: 1, opacity: 1, duration: 600, delay: a.stagger(110, { start: o.delay + 420 }), ease: 'outQuad' });
    var cab = el.querySelector('.plc__head .plc__us');
    return a.animate(cab, { scale: [1, 1.1, 1], duration: 700, delay: o.delay + 260 + filas.length * 110, ease: 'inOutQuad' });
  };
  // tocar una fila: su check salta (interacción pequeña, sin peso)
  document.addEventListener('click', function (e) {
    var fila = e.target.closest && e.target.closest('.plc__row:not(.plc__head)'); if (!fila || !A()) return;
    var ok = fila.querySelector('.plc__ok'); if (ok) A().animate(ok, { scale: [1, 1.45, 1], rotate: [0, 360], duration: 700, ease: 'outBack(2)' });
  });

  /* ------------------------------------------------------------------ ahorro */
  ONX.effects.pah = function (el, a, o) {
    var fills = el.querySelectorAll('.pah__fill'), fmt = function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); };
    a.utils.set(fills, { scaleX: 0 });
    a.animate(fills, { scaleX: 1, duration: 1300, delay: a.stagger(220, { start: o.delay }), ease: 'outExpo' });
    el.querySelectorAll('[data-pah-to]').forEach(function (b, i) {
      var to = Number(b.getAttribute('data-pah-to')), pre = b.getAttribute('data-pah-pre') || '', v = { n: 0 };
      a.animate(v, { n: to, duration: 1300, delay: o.delay + i * 220, ease: 'outExpo', onUpdate: function () { b.textContent = pre + fmt(v.n); } });
    });
    var caja = el.closest('.pah'), badge = caja && caja.querySelector('[data-pah-badge]');
    if (!badge) return;
    a.utils.set(badge, { scale: 0 });
    return a.animate(badge, { scale: 1, rotate: [-10, 0], duration: 1000, delay: o.delay + 1100, ease: 'outElastic(1, .55)',
      onBegin: function () { setTimeout(function () { var c = centro(badge, caja); chispas(caja, c.x, c.y, 18); }, 120); } });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pah-badge]'); if (!b || !A()) return;
    var caja = b.closest('.pah'), c = centro(b, caja);
    A().animate(b, { scale: [0.9, 1.12, 1], duration: 600, ease: 'outBack(2)' }); chispas(caja, c.x, c.y, 18);
  });
})();
